import { updateField } from 'vuex-map-fields';
import { mutationBuilder as builder } from './helpers/builder';

export default builder({
    updateField,
    updateState(state, { key, value }) {
        state[key] = value;
    },
    setDateOfBirth(state, payload) {
        state.date_of_birth = payload;
    },
    setMobile(state, mobile) {
        state.mobile = mobile;
    },
    hasSubmitted(state, bool) {
        state.submitted = bool;
    },
    hasPassword(state, bool) {
        state.has_password = bool;
    },
    setCountry(state, country) {
        state.user = { ...state.user, home_country: country };
    },
    resetHomeFields(state) {
        state.user = {
            ...state.user,
            home_state: '',
            home_street: '',
            home_city: '',
            home_postcode: ''
        };
    },
    home_state(state, payload) {
        state.user = { ...state.user, home_state: payload };
    },
    home_house_name(state, payload) {
        state.user = { ...state.user, home_house_name: payload };
    },
    home_house_number(state, payload) {
        state.user = { ...state.user, home_house_number: payload };
    },
    home_street(state, payload) {
        state.user = { ...state.user, home_street: payload };
    },
    home_city(state, payload) {
        state.user = { ...state.user, home_city: payload };
    },
    home_postcode(state, payload) {
        state.user = { ...state.user, home_postcode: payload };
    },
    mergeUser(state, user) {
        state.user = { ...state.user, ...user };
    },
    setAddon(state, payload) {
        state.addon = { ...state.addon, price: payload.price, currency: payload.currency };
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Marketing/mutations.js